export class MedicalChronologyConstants {
  static readonly FINISHED_CASE_READ_ONLY_REASON = "Finished cases are read-only for your role";
}

export const MED_CHRON_VIEW_TABS = {
  SUMMARY: "summary",
  VISITS: "visit",
  IMAGES: "images",
  FILES: "files",
  CHATS: "chats",
} as const;
